import { render, staticRenderFns } from "./DoKoDialogPovertyCheck.vue?vue&type=template&id=4026770d&scoped=true&"
import script from "./DoKoDialogPovertyCheck.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogPovertyCheck.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogPovertyCheck.vue?vue&type=style&index=0&id=4026770d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4026770d",
  null
  
)

export default component.exports